export default "https://cdn-web.disco.co/slack-validate-connection-mobile-2-d7ba72cf63561884e27ee0b09490cf78.png";